import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

function LinkButton(props) {
  const { path, linktext } = props;
  return (
    <Link
      to={path}
      className="bg-blue-500 xl:p-6 p-4 md:px-8 px-4 text-white xl:text-lg md:text-md text-sm text-black font-semibold m-3 hover:bg-blue-700"
    >
      {linktext}
    </Link>
  );
}

export default LinkButton;

LinkButton.propTypes = {
  path: PropTypes.string.isRequired,
  linktext: PropTypes.string.isRequired,
};
